function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}

function setCookie (key, value, time) {
  if (key === undefined) {
    return
  }
  if (time !== undefined) {
    var d = new Date()
    d.setTime(d.getTime() + time * 1000 * 60 * 60 * 24)
    document.cookie = key + '=' + value + ';expires=' + d.toGMTString()
  } else {
    document.cookie = key + '=' + value
  }
}

const unique = (arr) => {
  var tmp = []
  var str
  for (var i in arr) {
    let itemIndex = tmp.indexOf(arr[i])
    if (itemIndex === -1) {
      tmp.push(arr[i])
    } else {
      str = arr[i]
      tmp.splice(itemIndex, 1)
    }
  }
  tmp.unshift(str)
  return tmp
}

const setCookieArray = (name, value, day) => {
  const date = new Date()
  date.setDate(date.getDate() + day)
  const cookieObj = []
  if (getCookie(name) !== null) {
    if (getCookie(name).split(',').length >= 1) {
      for (let i = 0; i < getCookie(name).split(',').length; i++) {
        cookieObj.push(getCookie(name).split(',')[i])
      }
    } else {
      cookieObj.push(getCookie(name).split(','))
    }
  }
  cookieObj.push(value)
  let arr = unique(cookieObj)
  document.cookie = name + '=' + arr + ';expires=' + date
}
const getCookieArray = (name) => {
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(name + '=')
    if (start !== -1) {
      start = start + name.length + 1
      let end = document.cookie.indexOf(';', start)
      if (end === -1) end = document.cookie.length
      return unescape(document.cookie.substring(start, end))
    }
  }
  return null
}
const tryItNow = () => {
  var a = document.createElement('a')
  a.href = 'https://console.famikit.com/#/Register'
  a.target = '_blank'
  var e = document.createEvent('MouseEvents')
  e.initEvent('click', true, true)
  a.dispatchEvent(e)
}
export {getCookie, setCookie, unique, setCookieArray, getCookieArray, tryItNow}



// WEBPACK FOOTER //
// ./src/components/api/cookies.js